import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Brand } from "@/components/Brand";
import { useCustomerAuth } from "@/context/CustomerAuthContext";

const links = [
  { label: "Shows", href: "#shows" },
  { label: "About", href: "#about" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const cust = useCustomerAuth();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav data-testid="main-nav"
      className={`fixed top-0 left-0 w-full z-[90] transition-colors duration-500 ${
        scrolled ? "bg-[#F1F4F3]/85 backdrop-blur-xl border-b border-black/10" : "border-b border-transparent"
      }`}>
      <div className="flex justify-between items-center px-6 md:px-12 h-20">
        <a href="#top" data-testid="brand-logo"><Brand /></a>
        <div className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-${l.label.toLowerCase()}`}
               className="font-mono2 text-xs uppercase tracking-[0.18em] text-[#556673] hover:text-brand transition-colors">
              {l.label}
            </a>
          ))}
          <Link to={cust?.user ? "/library" : "/account"} data-testid="nav-account-link"
                className="font-mono2 text-xs uppercase tracking-[0.18em] text-brand hover:opacity-70 transition-opacity">
            {cust?.user ? "My Library" : "Sign In"}
          </Link>
          <Link to="/login" data-testid="nav-admin-link"
                className="font-mono2 text-xs uppercase tracking-[0.18em] text-[#0E1E2E] border border-black/15 px-4 py-2 hover:bg-brand hover:text-[#06111C] hover:border-brand transition-colors">
            Admin
          </Link>
        </div>
        <button data-testid="mobile-menu-btn" onClick={() => setOpen(!open)}
                className="md:hidden font-mono2 text-xs uppercase tracking-[0.18em] text-[#0E1E2E]">
          {open ? "Close" : "Menu"}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-[#F1F4F3] border-t border-black/10 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)}
               className="font-mono2 text-sm uppercase tracking-[0.18em] text-[#3A4A56]">{l.label}</a>
          ))}
          <Link to={cust?.user ? "/library" : "/account"} onClick={() => setOpen(false)} className="font-mono2 text-sm uppercase tracking-[0.18em] text-brand">{cust?.user ? "My Library" : "Sign In"}</Link>
          <Link to="/login" className="font-mono2 text-sm uppercase tracking-[0.18em] text-brand">Admin Login</Link>
        </div>
      )}
    </nav>
  );
};
